export enum ModuleManagerMenuItemType {
    // note: using a string enum to keep compatbility
    Divider = 'divider',
    MenuItem = 'menuItem',
    SubMenu = 'subMenu',
    CheckMenu = 'checkMenu',
    RadioCheckMenu = 'radioCheckMenu', //uses both radio and check
    HeaderItem = 'headerItem',
}

export enum ModuleManagerMenuItemPlacement {
    Default = 'default',
    AfterExport = 'afterExport',
}

/** Used for lists where the type can be any menu item type */
export interface IModuleManagerMenuItem {
    key?: string;
    name?: string;
    localizedName?: string;
    icon?: string;
    faIcon?: string;
    type?: ModuleManagerMenuItemType;
    placement?: string;
    click?: () => void;
    getEnabled?: () => boolean;
    readOnlyEnabled?: boolean;
    tooltip?: string;

    // from sub-menu
    subItems?: Array<IModuleManagerMenuItem>;
    getLocalizedName?: (i: number) => string;
    subMenuOpen?: boolean;
    mouseEnter?: ($event: Event) => void;
    mouseLeave?: ($event: Event) => void;
    closeMenu?: () => void;

    // from check menu
    getCheckItems?: () => Array<any>;
    getItemName?: (i: number) => string;
    isItemChecked?: (i: number) => boolean;
    onCheckClicked?: (i: number) => void;
    getItemInputType?: (i: number) => string;
}

export class ModuleManagerMenuItem {
    localizedName?: string;

    constructor(
        /** The key to identify this menuItem */
        public key?: string,
        /** The name to display on the module */
        public name?: string,
        /** The CSS class of the icon to display on the module */
        public icon?: string,
        /** The type of menu item */
        public type?: ModuleManagerMenuItemType,
        /** The placement in the menu, additional items are placed before the export option by default */
        public placement?: string,
        /**  The input type - radio or checkbox */
        public inputType?: string,
        /** The action to perform when this menuItem is clicked */
        public click?: () => any,
        /** Function called to check if a menu item is enabled */
        public getEnabled?: () => boolean,

        /** If set to true, this menu item will appear in the module on read-only dashboards */
        public readOnlyEnabled?: boolean,
    ) {
        this.localizedName = name;
    }
}

export class ModuleManagerSubMenu extends ModuleManagerMenuItem {
    subItems: Array<ModuleManagerMenuItem> = [];

    getLocalizedName: (i: number) => string;

    /** State for sub menus */
    subMenuOpen: boolean = false;

    mouseEnter() {
        this.subMenuOpen = true;
    }

    mouseLeave() {
        this.subMenuOpen = false;
    }

    closeMenu() {
        this.subMenuOpen = false;
    }
}

export class ModuleManagerCheckMenu extends ModuleManagerSubMenu {
    getCheckItems: () => Array<any>;
    /** Function called to retrieve the item name (for submenus) */
    getItemName: (i: number) => string;
    isItemChecked: (i: number) => boolean;
    onCheckClicked: (i: number) => void;
    getItemInputType?: (i: number) => string;
}
